decodePath